import React from "react";
import backgroundImage from "../../assets/images/BackGroundOfSectionTwo1.svg";
import logoSectionThree from "../../assets/images/logoSectionThree.svg";
import ScrollReveal from "../common/Reveal";

function SectionThreeHomPage() {
  return (
    <ScrollReveal
      className="caf-brand-band backgroundColor"
      style={{ backgroundImage: `url(${backgroundImage})` }}
      data-reveal-managed=""
    >
      <div className="caf-brand-band__inner flex min-h-[200px] items-center justify-center px-4 py-8 sm:min-h-[280px]">
        <img
          src={logoSectionThree}
          alt="CAF Sports"
          className="w-full max-w-[12rem] drop-shadow-lg sm:max-w-[18rem] lg:max-w-[22rem]"
        />
      </div>
    </ScrollReveal>
  );
}

SectionThreeHomPage.revealManaged = true;

export default SectionThreeHomPage;
